import { withDestroyEndpoint, withShowEndpoint, withStoreEndpoint, withUpdateEndpoint } from "@dgs/core";
import { MenuItemSaveRequest, MenuItemUpdateResource } from "../types";

const baseKey = ["menu-items"];

export const menuItemService = {
	baseKey,
	...withShowEndpoint<MenuItemUpdateResource>(baseKey),
	...withStoreEndpoint<MenuItemSaveRequest>(baseKey),
	...withUpdateEndpoint<MenuItemSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
};
